import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Select from 'react-select';
import Noimg from "../images/no_img.jpg";
import { getProduct, orderStatus } from "../api/ProductApi.js";
import { currentRegister } from "utility/Constant.js";
import { Link, useNavigate } from "react-router-dom";
import ProductCommon from "../components/ProductLike&Wish";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import no_data from "images/no_data.png";
import { getBranchId } from "utility/HeaderConfig";
import SEO from "components/headers/Seo";

const pageList = [
  { id: 1, label: 'NEW ARRIVALS', value: '/NewArrivals' },
  { id: 2, label: 'MOST LIKED PRODUCT', value: '/MostLiked' },
  { id: 3, label: 'TREND ON SHOPS', value: '/TrendOnShopComponent' },
  { id: 4, label: 'SHOP OUR EXCLUSIVE', value: '/ShopOurExclusiveComponent' },
  { id: 5, label: 'BEST SELLING', value: '/BestSellingComponent' },
];

const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "#643f6b" : "#e2d9e8",
    boxShadow: state.isFocused ? "0 0 0 2px #643f6b33" : "none",
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: ".04em",
    cursor: "pointer",
    "&:hover": { borderColor: "#643f6b" },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#643f6b" : state.isFocused ? "#f3eef6" : "#fff",
    color: state.isSelected ? "#fff" : "#13081a",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
  }),
  singleValue: (base) => ({ ...base, color: "#13081a" }),
  menu: (base) => ({ ...base, borderRadius: 8, overflow: "hidden", zIndex: 99 }),
};

export default function BestSellingComponent({ configImages }) {
  const history = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [size] = useState(2000);
  const [statuses, setStatuses] = useState({ sale: "", transfer: "", sold: "" });
  const [selectedOption, setSelectedOption] = useState(
    { id: 5, label: 'BEST SELLING', value: '/BestSellingComponent' }
  );

  useEffect(() => {
    Promise.all([
      orderStatus({ orderStatusName: "sale" }).then(d => d.response[0].id),
      orderStatus({ orderStatusName: "Transferred" }).then(d => d.response[0].id),
      orderStatus({ orderStatusName: "Sold" }).then(d => d.response[0].id),
    ]).then(([sale, transfer, sold]) => {
      setStatuses({ sale, transfer, sold });
      fetchBestSelling(sale, transfer, sold);
    }).catch(console.error);
    //eslint-disable-next-line
  }, []);

  const fetchBestSelling = (sale, transfer, sold) => {
    setLoading(true);
    if (!sale || !transfer || !sold) return;
    getProduct(size, {
      branch: getBranchId(),
      productLabel: 'BestSellers',
      removeNTP: "NTP-",
      removeHP: "HP-",
      beforeCreatedAt: currentRegister(),
      sortType: true,
      demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
      statusId: `${sale}, ${transfer}, ${sold}`,
    }).then(data => {
      setCategoryList(data.response.content);
      setLoading(false);
    }).catch(console.error);
  };

  const handleMenuChange = (item) => {
    setSelectedOption(item);
    history(item.value);
  };

  const imgSrc = (item) =>
    !item.images || item.images === "@#@" || item.images === "Image_Not_Available"
      ? Noimg
      : item.images.split("@#@")[0];

  return (
    <div style={{ background: "#faf8fc", minHeight: "100vh" }}>
      <SEO
        title="Best Selling — Sibiraja Nagai Maaligai LLP"
        description="Explore our best selling jewellery collection."
        name="Sibiraja Nagai Maaligai LLP"
        type="article"
      />

      {/* Breadcrumb */}
      <div className="ptSans px-sm-5 pt-2 px-5" style={{ background: "var(--surface-cream)", height: "70px" }}>
        <div className="mb-1" style={{ color: "var(--ink-700)", fontWeight: 500, fontSize: "14px", textTransform: "capitalize" }}>
          OUR BEST SELLING
        </div>
        <Link to="/" className="mx-1" style={{ color: "var(--ink-700)", textDecoration: "none", fontWeight: 350, fontSize: "10px" }}>HOME</Link>
        {" > "}
        <span className="mx-1" style={{ color: "var(--ink-700)", fontWeight: 350, fontSize: "10px", textTransform: "uppercase" }}>
          BEST SELLING
        </span>
      </div>

      <div className="container py-4">
        {/* Toolbar */}
        <div className="bsc-toolbar">
          <div className="bsc-count">
            {!loading && (
              <span>{categoryList.length} <span style={{ fontWeight: 400, color: "#888" }}>products</span></span>
            )}
          </div>
          <div style={{ width: 220 }}>
            <Select
              options={pageList}
              styles={selectStyles}
              value={selectedOption}
              onChange={handleMenuChange}
              isSearchable={false}
            />
          </div>
        </div>

        {/* Grid */}
        {loading ? (
          <div className="bsc-grid">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="bsc-skel">
                <Skeleton style={{ height: 240, borderRadius: "12px 12px 0 0" }} />
                <div style={{ padding: 14 }}>
                  <Skeleton height={10} style={{ marginBottom: 6, borderRadius: 4 }} />
                  <Skeleton height={13} style={{ marginBottom: 8, borderRadius: 4 }} />
                  <Skeleton height={17} width="40%" style={{ borderRadius: 4 }} />
                </div>
              </div>
            ))}
          </div>
        ) : categoryList.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <img src={no_data} alt="no-data" style={{ maxWidth: 220, opacity: 0.7 }} />
            <p style={{ color: "#888", marginTop: 16, fontSize: 14 }}>No products found.</p>
          </div>
        ) : (
          <div className="bsc-grid">
            {categoryList.map((item, i) => (
              <motion.div
                key={item.id || i}
                className="bsc-card"
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.25, delay: Math.min(i * 0.025, 0.4) }}
                onClick={() => history(`/ProductDetails/${item.id}`, { state: { categoryItem: item } })}
              >
                <div className="bsc-card-actions" onClick={e => e.stopPropagation()}>
                  <ProductCommon categoryItem={item} />
                </div>
                {item.stockStatus === "Sale" && (
                  <span className="bsc-badge">Available</span>
                )}
                <div className="bsc-img-wrap">
                  <img
                    src={imgSrc(item)}
                    alt={item.title || "Product"}
                    className="bsc-img"
                    loading="lazy"
                  />
                </div>
                <div className="bsc-card-body">
                  <p className="bsc-metal">{item.metalType}</p>
                  <p className="bsc-name" title={item.title}>{item.category}</p>
                  <div className="bsc-footer">
                    <span className="bsc-price">₹{Math.trunc(item.total).toLocaleString("en-IN")}</span>
                    {item.goldPurity && item.goldPurity !== "-" && (
                      <span className="bsc-purity">{item.goldPurity}</span>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        )}

        {/* Load more */}
        {!loading && categoryList.length > 0 && (
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <button
              className="bsc-loadmore"
              onClick={() => fetchBestSelling(statuses.sale, statuses.transfer, statuses.sold)}
            >
              Refresh
            </button>
          </div>
        )}
      </div>
    </div>
  );
}